module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "bg": "grey",
      "breadcrumbs": _vm.breadcrumbs
    }
  }, [_c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.isLoading,
      "size": 100,
      "height": true
    }
  }, [(_vm.isError) ? _c('AppHeading', {
    attrs: {
      "mod": "center, red"
    }
  }, [_vm._v("У нас произошел сбой в работе оборудования. Почитайте, пожалуйста, другие статьи, а позже попробуйте еще раз!")]) : (_vm.globalItems.length) ? _c('TransitionGroup', {
    attrs: {
      "tag": "div"
    }
  }, _vm._l((_vm.globalItems), function(ref, index) {
    var name = ref.name;
    var items = ref.items;
    var component = ref.component;

    return _c('section', {
      key: name
    }, [_c('AppHeading', {
      attrs: {
        "level": "3",
        "mod": "bold, uppercase"
      }
    }, [_vm._v(_vm._s(name))]), _c('ListLayout', [_c('ListPageLayout', {
      attrs: {
        "slot": "list",
        "mod": "bottom"
      },
      slot: "list"
    }, _vm._l((items), function(item, index) {
      return _c(component, _vm._b({
        key: index,
        tag: "component"
      }, 'component', item, false))
    }), 1)], 1)], 1)
  }), 0) : _c('AppHeading', {
    attrs: {
      "mod": "center"
    }
  }, [_vm._v("Нет ни одного предложения согласно выбранным критериям.")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffb26c4c","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/global-search/GlobalSearch.vue
// module id = 2ddcb7282729c45babb6
// module chunks = 71